/*
 * Copyright © 2017 TEKTELIC Communications Inc.
 */
/* eslint-disable import/no-unresolved, import/default */

import alarmsTemplate from './alarms.tpl.html';

/* eslint-enable import/no-unresolved, import/default */

/*@ngInject*/
export default function AlarmsRoutes($stateProvider, $injector) {

    var types = $injector.get('types');

    $stateProvider
        .state('home.alarms', {
            url: '/alarms',
            module: 'private',
            auth: [types.authority.PROVIDER_ADMIN.value, types.authority.CUSTOMER_ADMIN.value,
                types.authority.PROVIDER_USER.value, types.authority.CUSTOMER_USER.value],
            views: {
                "content@home": {
                    templateUrl: alarmsTemplate,
                    controllerAs: 'vm',
                    controller: 'AlarmsController'
                }
            },
            data: {
                pageTitle: 'alarm.alarms'
            },
            ncyBreadcrumb: {
                label: '{"icon": "notifications_active", "label": "alarm.alarms"}'
            }
        });
}



// WEBPACK FOOTER //
// ./src/app/alarm/alarms.routes.js